/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateEmail.defs.js'
export { main as default } from './updateEmail.defs.js'
